import React, { memo } from 'react';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import LoaderButton from '../../../shared/components/LoaderButton/LoaderButton';
import Back from '../../../shared/components/Back/Back';
import { useSecurityCode } from '../../hooks/authHooks';
import resetPasswordSchema from '../../schemas/resetPasswordSchema';
import styles from './resetPasswordForm.module.scss';

export default memo(function ResetPasswordForm(props) {
    useSecurityCode(props.deleteSecurityCode);

    const { t } = useTranslation(['common', 'validations', 'auth']);
    const handleSubmit = values => props.resetPasswordRequest(
        values.username,
        values.securityCode,
        values.password,
        props.history,
        props.location
    );

    return (
        <div className={styles.container}>
            <div className={styles.formContainer}>
                <Formik
                    initialValues={{
                        password: '',
                        repeatedPassword: '',
                        securityCode: props.securityCode,
                        username: props.username
                    }}
                    validationSchema={resetPasswordSchema}
                    onSubmit={handleSubmit}
                    render={formProps => (
                        <Form>
                            <div className={styles.fieldsContainer}>
                                <TextField
                                    type="password"
                                    label={t('auth:NEW_PASSWORD')}
                                    name="password"
                                    value={formProps.values.password}
                                    onChange={formProps.handleChange}
                                    onBlur={formProps.handleBlur}
                                    className={styles.field}
                                    disabled={props.isReseting}
                                    error={formProps.touched.password && !!formProps.errors.password}
                                    helperText={
                                        formProps.touched.password && !!formProps.errors.password
                                            ? <span>{t('validations:VALID_PASSWORD')}</span>
                                            : <span>{t('validations:VALID_PASSWORD')}</span>
                                    }
                                />
                                <TextField
                                    type="password"
                                    label={t('common:REPEATED_PASSWORD')}
                                    name="repeatedPassword"
                                    value={formProps.values.repeatedPassword}
                                    onChange={formProps.handleChange}
                                    onBlur={formProps.handleBlur}
                                    className={styles.field}
                                    disabled={props.isReseting}
                                    error={formProps.touched.repeatedPassword && !!formProps.errors.repeatedPassword}
                                    helperText={
                                        formProps.touched.repeatedPassword && !!formProps.errors.repeatedPassword
                                            ? <span>{t('validations:MATCH_PASSWORD')}</span>
                                            : ''
                                    }
                                />
                            </div>
                            <LoaderButton dictionary="common" inProgress={props.isReseting} text="SEND" />
                        </Form>
                    )}
                />
            </div>
            <div className={styles.backContainer}>
                <div className={styles.lineContainer}>
                    <hr />
                </div>
                <Back url={'reset-password-code'} />
            </div>
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.isReseting === nextProps.isReseting &&
        prevProps.securityCode === nextProps.securityCode &&
        prevProps.username === nextProps.username &&
        prevProps.resetPasswordRequest === nextProps.resetPasswordRequest &&
        prevProps.deleteSecurityCode === nextProps.deleteSecurityCode
);
